// import "./styles.css";
// import WheelComponent from "./WheelComponent";
// export default function App() {
//   const segments = ["2000", "5000", "10000","2000", "5000", "10000"];
//   const segColors = ["#F0CF50", "#815CD1", "#34A24F","#F0CF50", "#815CD1", "#34A24F"];
//   const onFinished = (winner) => {
//     console.log(winner);
//   };
//   return (
//     <div className="App">
//       <div id="wheelCircle">
//         <WheelComponent
//           segments={segments}
//           segColors={segColors}
//           winningSegment=""
//           onFinished={(winner) => onFinished(winner)}
//           primaryColor="black"
//           primaryColoraround="#ffffffb4"
//           contrastColor="white"
//           buttonText="Spin"
//           isOnlyOnce={false}
//           size={190}
//           upDuration={50}
//           downDuration={1000}
//         />
//       </div>
//     </div>
//   );
// }

import React from 'react';
import Wheel from './pages/wheel/Wheel';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import SpinAndWin from './pages/spincontent/SpinAndWin';
import "bootstrap/dist/css/bootstrap.min.css";
import PrivateRoute from './routes/PrivateRoute';
import PublicRoute from './routes/PublicRoute'
import MainLayout from './layout/MainLayout';
import Login from './pages/login/Login';
import Group from './pages/group/Group';
import Menu from './pages/menu/Menu';
import Quiz from './pages/quiz/Quiz';

const App = () => {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/public" element={<SpinAndWin />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/wheel/:data" element={<Wheel />} />
           
          <Route path="/login" element={<PublicRoute />}>
            <Route path="/login" element={<Login />} />
          </Route>

          <Route path="/" element={<PrivateRoute />} >
            <Route path="/" element={<MainLayout />}>
               <Route path="/" element={<Group />} /> 
               <Route path="/menu" element={<Menu />} /> 
             </Route>                    
          </Route>  

        </Routes>
      </BrowserRouter>
      <ToastContainer
        autoClose={3000}
        draggable={false}
        position="top-right"
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnHover
      />      
    </div>
  )
}

export default App
